@if (isMatMenu) {
  <button mat-menu-item
          [ngClass]="cssClass"
          [matTooltip]="title"
          [matTooltipDisabled]="!iconOnly"
          (click)="downloadFile()"
          data-test="dms-download-file-button-button">
    <i [hidden]="labelOnly" class="icon fa-fw fas fa-download"></i>
    <span [hidden]="iconOnly" class="icon-label">{{ title }}</span>
  </button>
} @else {
  <sk-button [appearance]="iconOnly ? 'icon' : 'text'"
             [color]="iconOnly ? 'unspecified' : 'primary'"
             [label]="!iconOnly ? title : ''"
             [matTooltip]="title"
             [matTooltipDisabled]="isMatMenu"
             (click)="downloadFile()"
             data-test="dms-download-file-button-button-2">
    @if (iconOnly) {
      <i [hidden]="labelOnly" class="icon fa-fw fas fa-download"></i>
    } @else {
      <ng-template buttonPrefix>
        <i [hidden]="labelOnly" class="icon fa-fw fas fa-download"></i>
      </ng-template>
    }
  </sk-button>
}
